import { FILTER_DATE_FROM } from './constants'

export const filterDateFrom = (date = '', event = null) => ({
  type: FILTER_DATE_FROM,
  date,
  event,
})
